import {Base64} from 'js-base64'
import {USER_INFO_STORAGE_KEY, USER_PERMISSION_KEY} from '../constants/appConstant'
import AppMenus from '../constants/appMenus'

//const storage = window.sessionStorage; // window.localStorage
const storage = window.localStorage
const harnessRedirectStorageKey = 'harness_gateway_redirect'

const captureHarnessRedirect = () => {
  try {
    const params = new URLSearchParams(window.location.search)
    const state = params.get('harness_state')
    const returnUrl = params.get('harness_return_url')
    if (state && returnUrl) {
      window.sessionStorage.setItem(harnessRedirectStorageKey, JSON.stringify({state, returnUrl}))
    }
  } catch (ex) {
    // Login must remain usable when an older browser has no sessionStorage.
  }
}

const completeHarnessRedirect = async token => {
  try {
    const raw = window.sessionStorage.getItem(harnessRedirectStorageKey)
    if (!raw || !window.g?.apiBaseUrl) return false
    const redirect = JSON.parse(raw)
    if (!redirect?.state || !redirect?.returnUrl) return false
    const base = window.g.apiBaseUrl.replace(/\/$/, '')
    const response = await window.fetch(`${base}/harness/gateway/complete`, {
      method: 'POST',
      credentials: 'include',
      headers: {'Authorization': `Bearer ${token}`, 'Auth-Type': 'ssofed', 'Content-Type': 'application/json'},
      body: JSON.stringify(redirect)
    })
    if (!response.ok) return false
    const body = await response.json()
    const destination = body?.code === 0 && body?.data?.redirectUrl
    if (!destination) return false
    window.sessionStorage.removeItem(harnessRedirectStorageKey)
    window.location.replace(destination)
    return true
  } catch (ex) {
    return false
  }
}

const authorize = (token, pspToken, permissionKeys) => {
  if (!token) {
    throw new Error('Token can not be null.')
  }
  storage.setItem(USER_INFO_STORAGE_KEY, Base64.encode(JSON.stringify({token})))
  storage.setItem(USER_PERMISSION_KEY, Base64.encode(JSON.stringify({permissions: permissionKeys})))
  void completeHarnessRedirect(token)
}
const setRefresh = (refreshToken) => {
  storage.setItem('refresh_token', Base64.encode(JSON.stringify(refreshToken)))
}
const getRefresh = () => {
  try {
    const refreshToken = storage.getItem('refresh_token')
    if (refreshToken) {
      return JSON.parse(Base64.decode(refreshToken))
    }
    return ''
  } catch (ex) {
    return ''
  }
}
const setUserCode = (userCode) => {
  storage.setItem('userCode', Base64.encode(JSON.stringify(userCode)))
}
const logout = () => {
  storage.removeItem(USER_INFO_STORAGE_KEY)
  storage.removeItem(USER_PERMISSION_KEY)
  storage.removeItem('userCode')
}

const getAuthInfo = () => {
  try {
    const authInfo = storage.getItem(USER_INFO_STORAGE_KEY)
    if (authInfo) {
      return JSON.parse(Base64.decode(authInfo))
    }
    return {
      token: '',
    }
  } catch (ex) {
    return {
      token: '',
    }
  }
}

const isAuthorized = () => getAuthInfo().token && true

const getToken = () => getAuthInfo().token

// const getUserCode = () => getAuthInfo().userCode;
const getUserCode = () => {
  try {
    const userCode = storage.getItem('userCode')
    if (userCode) {
      return JSON.parse(Base64.decode(userCode))
    }
    return []
  } catch (ex) {
    return []
  }
}
const getPermissions = () => {
  try {
    const permissions = storage.getItem(USER_PERMISSION_KEY)
    if (permissions) {
      return JSON.parse(Base64.decode(permissions)).permissions
    }
    return []
  } catch (ex) {
    return []
  }
}

const getMenus = () => {
  const userPermissionKeys = getPermissions()
  const appMenus = AppMenus.getMenus()
  const userMenus = []
  appMenus.forEach(menu => {
    if (menu.children && menu.children.length > 0) {
      const {...userMenu} = menu
      userMenu.children = []
      menu.children.forEach(cMenu => {
        if (userPermissionKeys?.includes(cMenu.key)) {
          userMenu.children && userMenu.children.push({...cMenu})
        }
      })

      if (userMenu.children && userMenu.children.length !== 0) {
        userMenus.push(userMenu)
      }
    } else if (menu.key && userPermissionKeys && userPermissionKeys.includes(`${menu.key}`)) {
      userMenus.push({...menu})
    }
  })
  return userMenus
}

export default {
  authorize,
  setUserCode,
  logout,
  getAuthInfo,
  isAuthorized,
  getUsername: getUserCode,
  getToken,
  getPermissions,
  getMenus,
  captureHarnessRedirect,
  setRefresh,
  getRefresh
}
